import React from 'react'

const CopyButton = ({sigId, buttonClicked}) => {

    const selectSig = (event) =>{
		var option = event.target.getAttribute("id");
		var node = document.getElementById(option + "Signature");
		
		if (document.body.createTextRange) {
	        const range = document.body.createTextRange();
	        range.moveToElementText(node);
	        range.select();
	    } else if (window.getSelection) {
	        const selection = window.getSelection();
	        const range = document.createRange();
	        range.selectNodeContents(node);
	        selection.removeAllRanges();
	        selection.addRange(range);
	    }

	    // Copy it to clipboard
	    document.execCommand("copy")

    }
    
    return(
        <button className="button full small break-above"
            onClick={selectSig}
            key={sigId}
            id={sigId}>
                Select &amp; Copy to Clipboard
        </button>
    )
}

export default CopyButton;